import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saVonrAccessibilityCellChartConfig } from '../cellChartConfigs';

interface VonrAccessibilitySaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const VonrAccessibilitySaCell: React.FC<VonrAccessibilitySaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saVonrAccessibilityCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default VonrAccessibilitySaCell;
